import { render, staticRenderFns } from "./core_gallery.vue?vue&type=template&id=463b481b&scoped=true"
import script from "./core_gallery.vue?vue&type=script&lang=js"
export * from "./core_gallery.vue?vue&type=script&lang=js"
import style0 from "./core_gallery.vue?vue&type=style&index=0&id=463b481b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b481b",
  null
  
)

export default component.exports